import { gql, useLazyQuery } from "@apollo/client";
import { toRelayId } from "graphqlsupport";

type Input = {
  currentReferralId: string;
};
type Output = {
  highPriorityReferral: {
    guid: string;
  };
};

type OnReferralResult = (result: { guid: string } | null) => void;

const query = gql`
  query SuggestPriorityReferral($currentReferralId: ID!) {
    highPriorityReferral(id: $currentReferralId) {
      id
      guid
    }
  }
`;
export const useSuggestPriorityReferral$ = (
  referralGuid: string,
  onResult: OnReferralResult,
) => {
  const [suggest, { data }] = useLazyQuery<Output, Input>(query, {
    variables: {
      currentReferralId: toRelayId(referralGuid, "Referral"),
    },
    fetchPolicy: "cache-and-network", // Ensure we always get fresh data and callbacks fire
    onCompleted: (result: Output | null) => {
      const priorityReferral = result?.highPriorityReferral ?? null;
      onResult(priorityReferral);
    },
    onError: () => {
      onResult(null);
    },
  });

  return {
    data: data?.highPriorityReferral ?? null,
    suggest,
  };
};
